import { render, staticRenderFns } from "./VueTrend.vue?vue&type=template&id=633b752c"
import script from "./VueTrend.vue?vue&type=script&lang=js"
export * from "./VueTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports